import { AxiosRequestConfig } from "axios";
import { GranularCatalogConfig } from "@granular/fabric-catalog-helpers";

import auth from "@granular/auth-svc-js";
import user from "@granular/user-svc-js";
import crops from "@granular/crops-svc-js";
import fields from "@granular/fields-svc-js";
import invite from "@granular/invite-svc-js";
import roles from "@granular/roles-svc-js";
import enrollments from "@granular/enrollments-svc-lambda-js";

import createInstance, { GranularCatalogInstance } from "./instance";

const granularCatalog: {
  createInstance: (
    catalogConfig: GranularCatalogConfig,
    instanceRequestConfig?: AxiosRequestConfig,
  ) => GranularCatalogInstance;
  auth: typeof auth;
  user: typeof user;
  crops: typeof crops;
  fields: typeof fields;
  invite: typeof invite;
  roles: typeof roles;
  enrollments: typeof enrollments;
} = {
  createInstance,
  auth,
  user,
  crops,
  fields,
  invite,
  roles,
  enrollments,
};

export default granularCatalog;
